import React, { useState, useEffect } from "react";
import { UnmountClosed } from "react-collapse";
import classNames from 'classnames';

import ModalAction from "fantastic/components/common/ModalAction";

const VisibilityConditionsModal = ({
  conditionsGroupLogical,
  conditions,
  recipientParameters,
  onChange,
  changeModalOpenState
}) => {

  const operators = {
    equal: '==',
    not_equal: '!=',
    less: '<',
    greater: '>',
    less_or_equal: '<=',
    greater_or_equal: '>=',
    contains: 'contains',
    is_empty: 'is_empty',
    is_not_empty: 'is_not_empty',
    is_true: 'is_true',
    is_false: 'is_false'
  }

  const conditionSelection = () => {
    return Object.entries(operators).map( (operator, i) => {
      const [name, value] = operator;
      const short_name = (name.startsWith('is') || name == 'contains') ? '' : `${value} `;
      return <option key={i} value={value}>{short_name}{i18n.t(`condition_operators.${name}`)}</option>
    });
  }

  const defaultStructure = () => [ { parameter: '', condition: operators.equal, value: '' } ]

  const [conditionRows, setStructure] = useState(conditions.value.length ? conditions.value : defaultStructure())

  const updateStructure = (e, rowID, key) => {
    const tempAry = [...conditionRows]
    tempAry[rowID][key] = e.target.value

    setStructure(tempAry)
  }

  const addStructure = () => {
    setStructure([...conditionRows, ...defaultStructure()])
  }

  const removeStructure = (rowID) => {
    const tempAry = [...conditionRows]
    tempAry.splice(rowID, 1)

    setStructure(tempAry)
  }

  const showConditionParameters = () => {
    let items = Object.keys(recipientParameters).map( (value, i) => {
      return <option key={i} value={value}>{value}</option>
    })

    return (
      <datalist id='condition-parameters'>
        { items }
      </datalist>
    )
  }

  const conditionRow = ({ parameter, condition, value }, i) => {
    return(
      <div className="conditions-list__item" key={i} >
        <div className="conditions-list__param">
          <input value={parameter} className='form-control' list='condition-parameters' onChange={(e)=> updateStructure(e, i, 'parameter')}/>
          { showConditionParameters() }
        </div>
        <div className="conditions-list__value">
          <select className='form-control' onChange={(e) => updateStructure(e, i, 'condition')} value={condition}>{conditionSelection()}</select>
          { !condition.startsWith('is') &&
            <input className='form-control' value={value} onChange={(e)=> updateStructure(e, i, 'value')}/>
          }
        </div>
        <div className="condition-list__remove">
          <button type="button" className="remove_condition btn btn-remove form-group-action" onClick={() => removeStructure(i)}></button>
        </div>
      </div>
    )
  }

  const rows = () => conditionRows.map(conditionRow)

  const [logical, setConditionGroupLogical] = useState(conditionsGroupLogical.value)

  const changeConditionGroupLogical = (val) => setConditionGroupLogical(val)

  const klassLogical = (val) => {
    return classNames({
      "active": logical === val
    })
  }

  const saveChanges = () => {
    onChange({
      [conditions.field]: conditionRows,
      [conditionsGroupLogical.field]: logical
    })

    changeModalOpenState(false)
  }

  const disabled = !conditionRows.every(({ parameter, condition, value }) => parameter.length && (value.length || condition.startsWith('is')));

  return (
    <ModalAction
      onAccept={() => saveChanges()}
      onReject={() => changeModalOpenState(false)}
      textReject={ i18n.t('cancel') }
      textAccept={ i18n.t('save') }
      disabledAccept={ disabled }
    >

      <div className="visible-condition">
        <div className="clear"></div>
        <div className="head">
          <div className="prefix">{ i18n.t('condition_prefix') }</div>
          <div className="btn-group custom-switcher">
            <label className={`btn ${klassLogical('and')}`} onClick={()=>{changeConditionGroupLogical('and')}}>
              { i18n.t('all') }
            </label>
            <label className={`btn ${klassLogical('or')}`} onClick={()=>{changeConditionGroupLogical('or')}}>
              { i18n.t('any') }
            </label>
          </div>
          <div className="suffix">{ i18n.t('condition_suffix') }</div>
        </div>

        <div className="conditions-list">
          {rows()}
        </div>

        <div className="links">
           <button type="button" className="btn btn-form" onClick={addStructure}> + { i18n.t('condition_add') }</button>
        </div>
      </div>

    </ModalAction>
  );

};

export default VisibilityConditionsModal;
